import React, {useState} from 'react';

import {PrintPreferences} from 'notebook/mediocre/print/PrintConstants';
import preferences from 'Preferences';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import TimezonePickerDropdown from 'ui-library/dropdowns/TimezonePickerDropdown';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import Menu from 'ui-library/menus/Menu';

export default function PrintLabelTimezonePicker(): JSX.Element {
  const [timezone, setTimezone] = useState(preferences.get(PrintPreferences.LABEL_PRINTING_TIMEZONE));
  const onChange = async (timezone: string): Promise<void> => {
    await preferences.set(PrintPreferences.LABEL_PRINTING_TIMEZONE, timezone);
    setTimezone(timezone);
  };

  return (
    <div>
      <Row>
        <Col md={12}>
          <FieldLabel className="u-small-spacing-top" isRequired={true} label="Timezone" />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <TimezonePickerDropdown
            disabled={false}
            value={timezone}
            onChange={onChange}
            menuProps={{
              height: Menu.HEIGHTS.MEDIUM,
              width: Menu.WIDTHS.FULL,
            }}
          />
        </Col>
      </Row>
    </div>
  );
}
